'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_io$002eintela$002esites$002edigitalinternship$002epages$002e$002dPricing$002dPage$0024$002dTier from "./io.intela.sites.digitalinternship.pages.-Pricing-Page$-Tier.js";
var $p;
/** @constructor */
function $c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$(outer) {
  this.tv = null;
  if ((outer === null)) {
    throw new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException();
  }
  this.tv = outer;
}
export { $c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$ as $c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$ };
$p = $c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$;
/** @constructor */
function $h_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$() {
}
export { $h_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$ as $h_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$ };
$h_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$.prototype = $p;
$p.lh = (function(name, segment, monthly, annual, per, blurb, ctaLabel, ctaPage, ctaStyle, popular, features) {
  return new $j_io$002eintela$002esites$002edigitalinternship$002epages$002e$002dPricing$002dPage$0024$002dTier.$c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier(this.tv, name, segment, monthly, annual, per, blurb, ctaLabel, ctaPage, ctaStyle, popular, features);
});
$p.t = (function() {
  return "Tier";
});
var $d_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$, "io.intela.sites.digitalinternship.pages.PricingPage$Tier$", ({
  fp: 1,
  y: 1,
  N: 1
}));
export { $d_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$ as $d_Lio_intela_sites_digitalinternship_pages_PricingPage$Tier$ };
//# sourceMappingURL=io.intela.sites.digitalinternship.pages.-Pricing-Page$-Tier$.js.map
